import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import LearnLayout from '../../components/learn/LearnLayout';
import RegionResources from '../../components/learn/RegionResources';
import { usePageMeta } from '../../hooks/usePageMeta';
import { useSsrLearnRoute } from '../../hooks/useSsrLearnRoute';
import { getRegionByCode, getLearnManifest } from '../../content/learn/registry';

function LearnRegionPage() {
  const { regionCode } = useParams();
  const region = getRegionByCode(regionCode);
  const manifest = getLearnManifest();

  useSsrLearnRoute(region ? `/learn/regions/${region.code}` : '/learn/regions');
  const metaEntry = region
    ? manifest.regions.items.find((r) => r.code === region.code)
    : null;

  usePageMeta({
    title:
      metaEntry?.title ||
      (region ? `Report scams in ${region.name} | WhoDatNumber` : 'Report scams by country | WhoDatNumber'),
    description: metaEntry?.description || manifest.regions.index.description,
    canonicalPath: region ? `/learn/regions/${region.code}` : '/learn/regions',
  });

  if (!region) {
    return <Navigate to="/learn/regions" replace />;
  }

  return (
    <LearnLayout
      title={`${region.flag} ${region.name}`}
      description="Official reporting links and local scam tips."
      breadcrumb={
        <>
          <Link to="/learn" className="hover:underline">
            Safety guides
          </Link>
          {' / '}
          <Link to="/learn/regions" className="hover:underline">
            Regions
          </Link>
          {` / ${region.name}`}
        </>
      }
    >
      {region.localTips?.length > 0 && (
        <section className="mb-8">
          <h2 className="text-lg font-bold text-gray-900 mb-3">Local tips</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            {region.localTips.map((tip) => (
              <li key={tip}>{tip}</li>
            ))}
          </ul>
        </section>
      )}

      <section>
        <h2 className="text-lg font-bold text-gray-900 mb-4">Official resources</h2>
        <RegionResources resources={region.resources} />
      </section>

      <p className="mt-8 text-sm text-gray-600">
        <Link to="/learn/common-phone-scams" className="text-blue-600 hover:underline">
          Common phone scams
        </Link>
        {' · '}
        <Link to="/learn/after-a-scam-call" className="text-blue-600 hover:underline">
          After a scam call checklist
        </Link>
      </p>
    </LearnLayout>
  );
}

export default LearnRegionPage;

